"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslation } from "react-i18next";

interface DeleteDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onDelete: () => void
  previewName: string
}

export function DeleteDialog({ isOpen, onOpenChange, onDelete, previewName }: DeleteDialogProps) {
  const { t, i18n } = useTranslation("common");

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className={i18n.language === "ar" ? "rtl" : ""}
        style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
      >
        <AlertDialogHeader>
          <AlertDialogTitle
            className={i18n.language === "ar" ? "text-right" : "text-left"}
          >
            {t("deleteDialog.title")}
          </AlertDialogTitle>
          <AlertDialogDescription
            className={i18n.language === "ar" ? "text-right" : "text-left"}
          >
            {t("deleteDialog.description", { previewName })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("buttons.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDelete}
            className="bg-destructive text-destructive-foreground"
          >
            {t("buttons.delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

